import { render } from "./teaStudioList.vue?vue&type=template&id=a4e6de84&scoped=true"
import script from "./teaStudioList.vue?vue&type=script&lang=js"
export * from "./teaStudioList.vue?vue&type=script&lang=js"

import "./teaStudioList.vue?vue&type=style&index=0&id=a4e6de84&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4e6de84"]])

export default __exports__